import { constantsData, formFieldNamesData } from "@/data";
import { InputTypeEnum } from "@/enums";

const {
    email,
    firstName,
    lastName,
    userName,
} = constantsData.forms.profile.edit;

const {
    email: emailFieldName,
    firstName: firstNameFieldName,
    lastName: lastNameFieldName,
    username: usernameFieldName,
} = formFieldNamesData;

export const profileFormData = [
    {
        description: userName.description,
        label: userName.label,
        name: usernameFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        description: firstName.description,
        label: firstName.label,
        name: firstNameFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        description: lastName.description,
        label: lastName.label,
        name: lastNameFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        description: email.description,
        isDisabled: true,
        label: email.label,
        name: emailFieldName,
        type: InputTypeEnum.EMAIL,
    },
];
